// Classes
import { CbBiometric } from '@openbank/cf-ui-framework';
// Enmumerations
import { BiometricContextsEnum } from 'enumerations/biometric/biometric.enum';

const loadBiometric = async (context: BiometricContextsEnum): Promise<void> => {
  const biometric = CbBiometric.getInstance();

  if (!biometric.loaded) {
    await biometric.load();
  }
  biometric.setContext(context);
};

const setBiometricCsid = (csid: string): void => {
  const biometric = CbBiometric.getInstance();

  if (biometric.loaded) {
    biometric.setCustomerSessionId(csid);
  }
};

export { loadBiometric, setBiometricCsid };
